<template>
  <MBBS :medium="66" email="preeti@aliff.in" phone="9152549789" />
</template>

<script>
import MBBS from "./MBBS.vue";
export default {
  components: {
    MBBS,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/MBBSFair/MiraRoad.vue